import { darkColors, secondaryColors, StatusTagEnum, Tag } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledMachineWrapper = styled.div`
  display: flex;
  padding: 2.4rem;
  justify-content: space-between;
  align-items: center;
  background: ${({ theme }) => theme.colors.secondary.main};
  border-radius: ${({ theme }) => theme.radius.small};
  gap: 1.6rem;
`;

export const StyledTitle = styled.span`
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${secondaryColors.grey[100]};
  margin-right: 1rem;
  vertical-align: middle;
`;

export const StyledTag = styled(Tag)<{ status: StatusTagEnum }>`
  background: ${({ status }) => (status === StatusTagEnum.GREEN ? '#224633' : '#493042')};
  color: ${secondaryColors.grey[100]};
  min-height: 3rem;
  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    width: 100%;
  }
`;

export const StyledTagTitle = styled.span`
  font-size: 1.4rem;
  line-height: 1.6rem;
`;

export const StyledPropsList = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;
  gap: 2.4rem;
  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 1.8rem;
  }
`;

export const StyledPropItem = styled.span`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`;

export const StyledIpAddress = styled.span`
  color: ${({ theme }) => theme.colors.primary.main};
`;

export const StyledPropsListAndCtaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const StyledIpAddressWrapper = styled.span`
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
`;

export const StyledToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.6rem;
  justify-content: flex-start;
  button:first-child {
    background-color: transparent;
    border-color: ${darkColors.button.secondary.border};
    color: ${darkColors.text.main};
    &:hover:not(:disabled) {
      background-color: ${darkColors.button.secondary.hover};
      color: ${darkColors.black};
    }
  }
`;

export const StyledImage = styled.img`
  vertical-align: middle;
`;
